module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.viewClass
  }, [_c('keep-alive', [(_vm.$route.meta && _vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "view"
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta || !_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "view"
  }) : _vm._e(), _vm._v(" "), (_vm.headVisible) ? _c('app-head', {
    attrs: {
      "backVisible": _vm.backVisible
    }
  }) : _vm._e(), _vm._v(" "), (_vm.footVisible) ? _c('app-foot') : _vm._e(), _vm._v(" "), (!_vm.isToolDisabled) ? _c('app-tool') : _vm._e(), _vm._v(" "), (!_vm.isDownVisible) ? _c('a', {
    staticClass: "download scaleE",
    attrs: {
      "href": "http://www.fytvapp.com/mobile/"
    }
  }, [_vm._v("\n        点此安装福音TV App"), _c('br'), _vm._v("访问FYTV.NET下载安装观看更多主内视频\n    ")]) : _vm._e(), _vm._v(" "), _c('app-share'), _vm._v(" "), (_vm.welcomeVisible) ? _c('welcome', {
    attrs: {
      "disable": false
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58a51c0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/App.vue
// module id = 328
// module chunks = 0